import React from "react";
import ListaFavoritos from "../components/Favourite";

const Favoritos = () => {

    return (
        <div className="min-h-screen bg-black text-white p-4  items-center">
            <h3 className="text-3xl font-bold text-white text-center 
               drop-shadow-[0_0_10px_rgba(173,216,230,0.8)] 
               shadow-lg font-montserrat mt-20"> MIS FAVORITOS</h3>
            <ListaFavoritos />
        </div>
    );
}
export default Favoritos;

